/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CardsRouteImport } from './routes/cards'
import { Route as FormsRouteImport } from './routes/forms'
import { Route as GamesRouteImport } from './routes/games'
import { Route as IncidentsRouteImport } from './routes/incidents'
import { Route as JerseysRouteImport } from './routes/jerseys'
import { Route as PracticeRouteImport } from './routes/practice'
import { Route as RefereesRouteImport } from './routes/referees'
import { Route as StandingsRouteImport } from './routes/standings'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CardsRoute = CardsRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsRoute = FormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesRoute = GamesRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => rootRouteImport,
} as any)
const IncidentsRoute = IncidentsRouteImport.update({
  id: '/incidents',
  path: '/incidents',
  getParentRoute: () => rootRouteImport,
} as any)
const JerseysRoute = JerseysRouteImport.update({
  id: '/jerseys',
  path: '/jerseys',
  getParentRoute: () => rootRouteImport,
} as any)
const PracticeRoute = PracticeRouteImport.update({
  id: '/practice',
  path: '/practice',
  getParentRoute: () => rootRouteImport,
} as any)
const RefereesRoute = RefereesRouteImport.update({
  id: '/referees',
  path: '/referees',
  getParentRoute: () => rootRouteImport,
} as any)
const StandingsRoute = StandingsRouteImport.update({
  id: '/standings',
  path: '/standings',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cards': typeof CardsRoute
  '/forms': typeof FormsRoute
  '/games': typeof GamesRoute
  '/incidents': typeof IncidentsRoute
  '/jerseys': typeof JerseysRoute
  '/practice': typeof PracticeRoute
  '/referees': typeof RefereesRoute
  '/standings': typeof StandingsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cards': typeof CardsRoute
  '/forms': typeof FormsRoute
  '/games': typeof GamesRoute
  '/incidents': typeof IncidentsRoute
  '/jerseys': typeof JerseysRoute
  '/practice': typeof PracticeRoute
  '/referees': typeof RefereesRoute
  '/standings': typeof StandingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cards': typeof CardsRoute
  '/forms': typeof FormsRoute
  '/games': typeof GamesRoute
  '/incidents': typeof IncidentsRoute
  '/jerseys': typeof JerseysRoute
  '/practice': typeof PracticeRoute
  '/referees': typeof RefereesRoute
  '/standings': typeof StandingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cards'
    | '/forms'
    | '/games'
    | '/incidents'
    | '/jerseys'
    | '/practice'
    | '/referees'
    | '/standings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cards'
    | '/forms'
    | '/games'
    | '/incidents'
    | '/jerseys'
    | '/practice'
    | '/referees'
    | '/standings'
  id:
    | '__root__'
    | '/'
    | '/cards'
    | '/forms'
    | '/games'
    | '/incidents'
    | '/jerseys'
    | '/practice'
    | '/referees'
    | '/standings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CardsRoute: typeof CardsRoute
  FormsRoute: typeof FormsRoute
  GamesRoute: typeof GamesRoute
  IncidentsRoute: typeof IncidentsRoute
  JerseysRoute: typeof JerseysRoute
  PracticeRoute: typeof PracticeRoute
  RefereesRoute: typeof RefereesRoute
  StandingsRoute: typeof StandingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cards': {
      id: '/cards'
      path: '/cards'
      fullPath: '/cards'
      preLoaderRoute: typeof CardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms': {
      id: '/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof FormsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games': {
      id: '/games'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof GamesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/incidents': {
      id: '/incidents'
      path: '/incidents'
      fullPath: '/incidents'
      preLoaderRoute: typeof IncidentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jerseys': {
      id: '/jerseys'
      path: '/jerseys'
      fullPath: '/jerseys'
      preLoaderRoute: typeof JerseysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/practice': {
      id: '/practice'
      path: '/practice'
      fullPath: '/practice'
      preLoaderRoute: typeof PracticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referees': {
      id: '/referees'
      path: '/referees'
      fullPath: '/referees'
      preLoaderRoute: typeof RefereesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/standings': {
      id: '/standings'
      path: '/standings'
      fullPath: '/standings'
      preLoaderRoute: typeof StandingsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CardsRoute: CardsRoute,
  FormsRoute: FormsRoute,
  GamesRoute: GamesRoute,
  IncidentsRoute: IncidentsRoute,
  JerseysRoute: JerseysRoute,
  PracticeRoute: PracticeRoute,
  RefereesRoute: RefereesRoute,
  StandingsRoute: StandingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
